import { FC, useContext } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';

import { BillingCycle } from '@/features/common/pricing';

import { PricingPageContext } from '../../../../contexts';

import styles from './styles.module.scss';

export const BillingCycleSwitcher: FC = () => {
  const { t } = useTranslation('pricingV2');
  const { billingCycle, onChangeBillingCycle, maxAnnualDiscount } =
    useContext(PricingPageContext);
  const checked = billingCycle === BillingCycle.Yearly;

  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>
        <input
          type="checkbox"
          className={styles.input}
          checked={billingCycle === BillingCycle.Yearly}
          onChange={() =>
            onChangeBillingCycle(
              billingCycle === BillingCycle.Yearly
                ? BillingCycle.Monthly
                : BillingCycle.Yearly,
            )
          }
        />
        <div className={styles.container}>
          <div className={styles.switcher} />
          <div className={clsx(styles.item, { [styles.checked]: !checked })}>
            <span className={styles.itemText}>{t('billingCycleSwitcher.monthly')}</span>
          </div>
          <div
            className={clsx(styles.item, {
              [styles.checked]: checked,
            })}
          >
            <span className={styles.itemText}>{t('billingCycleSwitcher.yearly')}</span>
            <div className={styles.itemBadge}>
              {t('billingCycleSwitcher.yearlyDiscount', {
                discount: maxAnnualDiscount,
              })}
            </div>
          </div>
        </div>
      </label>
    </div>
  );
};
